






import { Component, Vue, Watch } from 'vue-property-decorator';
import { InitData } from '@/module/user/store';
import { VuetifyThemes } from 'vuetify/types/services/theme';

Component.registerHooks(['beforeRouteEnter', 'beforeRouteUpdate', 'beforeRouteLeave']);

@Component({ components: {} })
export default class Main extends Vue {
    private shortInterval!: number;
    private mediumInterval!: number;

    private xUserAgentDarkMode = false;

    private get userAgentDarkMode() {
        return this.xUserAgentDarkMode;
    }

    private set userAgentDarkMode(val: boolean) {
        this.xUserAgentDarkMode = val;
    }

    private get isDarkMode() {
        return this.$store.getters.darkMode === 0 ? this.userAgentDarkMode : this.$store.getters.darkMode === 2;
    }

    private get themes() {
        return this.$store.getters.themes;
    }

    @Watch('isDarkMode', { immediate: true })
    public onDarkModeChanged(val: boolean) {
        this.$vuetify.theme.dark = val;
    }

    @Watch('themes', { immediate: true })
    public inThemeChanged(val: VuetifyThemes) {
        if (val && val.light) {
            Object.assign(this.$vuetify.theme.themes.light, val.light);
        }
        if (val && val.dark) {
            Object.assign(this.$vuetify.theme.themes.dark, val.dark);
        }
    }

    public async created() {
        this.retrieveUserAgentDarkMode();
        let action = 'lookupSession';

        const INITIAL_DATA: InitData = (window as any).__DEFAULT__DATA__;
        this.$i18n.setLocaleMessage('def', INITIAL_DATA.app.initialLocale);
        await this.$store.dispatch('loadInitialData', INITIAL_DATA);

        if (this.$store.getters.isAuthenticated) {
            if (
                INITIAL_DATA.login !== 'server' &&
                this.$store.getters.unloadTime &&
                new Date().getTime() - Date.parse(this.$store.getters.unloadTime) > 3000
            ) {
                action = 'logoutUser';
            } else {
                this.$store.commit('disableUnloadTime');
            }
            await this.$store.dispatch(action);
        }
        this.initResetIdleListener();
        this.startMediumInterval();
        this.startShortInterval();
    }

    public beforeDestroy() {
        clearInterval(this.shortInterval);
        clearInterval(this.mediumInterval);
    }

    private checkDBSession() {
        if (this.$store.getters.isAuthenticated) {
            this.$store.dispatch('lookupSession');
        }
    }

    private checkLogoutTimeout() {
        if (this.$store.getters.isAuthenticated) {
            if (this.$store.getters.idleTime >= this.$store.getters.logoutTimeout) {
                this.$store.dispatch('logoutUser');
            } else {
                this.$store.commit('incrTimer');
            }
        }
    }

    private initResetIdleListener() {
        document.body.addEventListener('click', () => this.resetIdleTimer());
        document.body.addEventListener('keydown', () => this.resetIdleTimer());
        document.body.addEventListener('touchstart', () => this.resetIdleTimer());
    }

    private resetIdleTimer() {
        this.$store.commit('resetTimer'); // state.session.idleTime = 0;
    }

    private retrieveUserAgentDarkMode() {
        if (this.userAgentDarkMode !== window.matchMedia('(prefers-color-scheme: dark)').matches) {
            this.userAgentDarkMode = !this.userAgentDarkMode;
        }
    }

    private startMediumInterval() {
        this.shortInterval = setInterval(() => {
            this.checkDBSession();
        }, 10000);
    }

    private startShortInterval() {
        this.mediumInterval = setInterval(() => {
            if (this.$store.getters.logoutTimeout > 0) {
                this.checkLogoutTimeout();
            }
            this.retrieveUserAgentDarkMode();
        }, 1000);
    }
}
